import React from "react";
import { useParams, Link } from "react-router-dom";
import Footer from "../Components/Footer";
import CTASection from "../Components/CTASection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Image4 from "../Images/image 7.png";
import Image5 from "../Images/image 5.png";
import Image6 from "../Images/image 6.png";
import "../Styles/ServiceDetail.css";

const servicesData = {
  "drywall-painting": {
    title: "Drywall Painting",
    heroImage: Image4,
    subtitle: "Expert painting services that transform your space with premium finishes",
    description: "From small repairs to complete remodels, no job is too big or too small. Our professional painters deliver flawless finishes with premium-grade paints that stand the test of time. We carefully prepare every surface to ensure perfect adhesion and a smooth, lasting result.",
    description2: "Whether you're refreshing a single room or repainting your entire property, our team brings precision and attention to detail that sets us apart. We use only top-quality paints and materials for results that look beautiful for years.",
    features: [
      "Interior & exterior painting",
      "Color consultation & planning",
      "Surface preparation & priming",
      "Premium paint products only",
      "Clean lines & flawless finishes",
      "Furniture & floor protection",
      "Drywall repair before painting",
      "Multi-coat application"
    ],
    process: [
      { step: "Consultation", desc: "We assess your space, discuss colors, and provide a detailed estimate." },
      { step: "Preparation", desc: "Proper surface prep including cleaning, sanding, priming, and masking." },
      { step: "Application", desc: "Expert multi-coat application with premium paints for even coverage." },
      { step: "Final Touch", desc: "Inspection, touch-ups, cleanup, and your complete satisfaction." }
    ]
  },
  "demolition-repair": {
    title: "Demolition Repair",
    heroImage: Image5,
    subtitle: "Complete drywall removal and replacement for damaged or outdated walls",
    description: "Demolition repair involves removing and disposing of damaged or outdated drywall and replacing it with new materials. Whether from water damage, age, or renovation needs, we restore your walls to perfect condition with seamless patches and finishes.",
    description2: "Our team handles everything from small patch repairs to full wall replacements. We match existing textures perfectly so repairs blend seamlessly with surrounding surfaces. Fast, clean, professional results every time.",
    features: [
      "Damage assessment & planning",
      "Safe material removal & disposal",
      "New drywall installation",
      "Seamless taping & mudding",
      "Texture matching",
      "Water damage restoration",
      "Structural repairs",
      "Complete cleanup"
    ],
    process: [
      { step: "Assessment", desc: "Thorough inspection to determine the extent of damage and best approach." },
      { step: "Demolition", desc: "Safe removal of damaged materials with proper containment and disposal." },
      { step: "Installation", desc: "New drywall hung, taped, mudded, and sanded to perfection." },
      { step: "Finishing", desc: "Texture matching, priming, and final finish for seamless results." }
    ]
  },
  "popcorn-removal": {
    title: "Popcorn Removal",
    heroImage: Image6,
    subtitle: "Modernize your ceilings with smooth, contemporary finishes",
    description: "Popcorn ceilings are outdated and can make any space feel old. Our professional popcorn texture removal service transforms your ceilings from bumpy and dated to smooth and modern. We handle the entire process safely and efficiently.",
    description2: "Our process includes careful scraping, skim coating, sanding, priming, and final painting. We protect your floors and furniture throughout the process and leave your space spotless when we're done.",
    features: [
      "Safe texture scraping",
      "Skim coating & smoothing",
      "Professional sanding",
      "Primer & paint application",
      "Furniture & floor protection",
      "Dust containment systems",
      "Smooth ceiling finishes",
      "Complete post-job cleanup"
    ],
    process: [
      { step: "Protection", desc: "We cover all furniture, floors, and walls to prevent any damage." },
      { step: "Removal", desc: "Careful scraping of popcorn texture with proper dust control." },
      { step: "Smoothing", desc: "Skim coat application, sanding, and surface perfecting." },
      { step: "Finishing", desc: "Primer and paint for a beautiful, smooth modern ceiling." }
    ]
  }
};

function ServiceDetail() {
  const { slug } = useParams();
  const service = servicesData[slug];

  if (!service) {
    return (
      <div>
        <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "80px" }}>
          <div style={{ textAlign: "center" }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "28px", marginBottom: "16px" }}>Service Not Found</h2>
            <Link to="/services" style={{ color: "#2EBCB3", fontWeight: "600" }}>← Back to Services</Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="sd-page">
      {/* Hero */}
      <section className="inner-hero">
        <div className="inner-hero-bg">
          <img src={service.heroImage} alt={service.title} className="inner-hero-img" />
        </div>
        <div className="inner-hero-overlay"></div>
        <div className="inner-hero-content">
          <span className="section-label">OUR SERVICES</span>
          <h1>{service.title}</h1>
          <p>{service.subtitle}</p>
          <div className="inner-hero-breadcrumb">
            <Link to="/">Home</Link> <span>/</span> <Link to="/services">Services</Link> <span>/</span> {service.title}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="sd-content">
        <div className="sd-content-inner">
          <div className="sd-text">
            <h2>About This Service</h2>
            <p>{service.description}</p>
            <p>{service.description2}</p>

            <div className="sd-features">
              <h3>What's Included</h3>
              <div className="sd-features-grid">
                {service.features.map((feature, i) => (
                  <div className="sd-feature-item" key={i}>
                    <FontAwesomeIcon icon={faCheck} className="sd-feature-icon" />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="sd-sidebar">
            <div className="sd-sidebar-card">
              <h3>Our Process</h3>
              <div className="sd-process-list">
                {service.process.map((step, i) => (
                  <div className="sd-process-item" key={i}>
                    <div className="sd-process-num">{i + 1}</div>
                    <div>
                      <strong>{step.step}</strong>
                      <p>{step.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="sd-sidebar-cta">
              <h3>Ready to Get Started?</h3>
              <p>Get a free, no-obligation estimate for your project today.</p>
              <Link to="/contact-us" className="sd-cta-btn">Get Free Estimate</Link>
              <a href="tel:+12396012421" className="sd-cta-phone">Or call: 239-601-2421</a>
            </div>
          </div>
        </div>
      </section>

      <CTASection />
      <Footer />
    </div>
  );
}

export default ServiceDetail;
